<template>
  <TranslationFormPart
      id="failedpairingscreen"
      key="failedpairingscreen"
      :form-settings="translationFormSettings"
      :disabled="!isEditable"
      :section-title="$gettext('Stránka neúspěšného párování')"
      v-model="entity.failed_pairing_screen"
  />
</template>

<script>

import TranslationFormPart from "../../../common/TranslationFormPart.vue";

export default {
  name: "FailedPairingScreen",
  components: {TranslationFormPart},
  props: {
    entity: Object,
    isEditable: Boolean,
  },
  data(){
    return {
      translationFormSettings: [
        {
          name: "title",
          type: "text",
          title: this.$gettext("Titulek chybové obrazovky"),
          required: false,
        },
        {
          name: "body_html",
          type: "textarea",
          title: this.$gettext("HTML chybové obrazovky"),
          required: false,
        }
      ]
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/initialProcessSetup/forms/FailedPairingScreen.vue